import styled, { css } from "styled-components";
import { IconButton } from "@mui/material";

export const Container = styled.div<{ customMargin: string }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: {props => props.customMargin};
  user-select: none;
`;

interface ICountProps {
	$isRemoveArrow: boolean;
}
export const Count = styled.div<ICountProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 60%;
	user-select: none;
	border-top: 1px solid ${({ theme }) => theme.pantone2726C};
	border-bottom: 1px solid ${({ theme }) => theme.pantone2726C};

	${({ $isRemoveArrow }) =>
		$isRemoveArrow &&
		css`
			border: 1px solid ${({ theme }) => theme.pantone2726C};
			max-width: 40px;
			border-radius: 6px;
			margin: 0 auto;
		`}
`;

const ArrowBase = styled(IconButton)`
	&&& {
		color: ${({ theme }) => theme.pantone2726C};
		width: 20%;
		border-radius: 0;
		padding: 0.2rem 0.8rem;

		.MuiSvgIcon-root {
			font-size: 0.8rem;
		}

		&:disabled {
			filter: grayscale(0.6);
			background: ${({ theme }) => theme.pantone642C};
		}
	}
`;
export const ArrowLeft = styled(ArrowBase)`
	&&& {
		border: 1px solid ${({ theme }) => theme.pantone2726C};
		border-radius: 4px 0 0 4px;
		> span {
			transform: rotate(180deg);
		}
	}
`;
export const ArrowRight = styled(ArrowBase)`
	&&& {
		border: 1px solid ${({ theme }) => theme.pantone2726C};
		border-radius: 0 4px 4px 0;
	}
`;
